import { ISearchConfig } from '../../modules/search'
import { convertTimeRangeToFilterFacet, getTimeRangeFromTime, Time } from '../../modules/time'
interface Configs {
  searchConfigs: {
    [key: string]: ISearchConfig
  }
}
export const configs = {
  searchConfigs: {
    recommended: {
      index: ['events_search'],
      modal: 'events_search',
    },
    free: {
      index: ['events_search'],
      modal: 'events_search',
      facets: [
        {
          name: 'isAccessibleForFree',
          options: [
            {
              value: 'true',
              selected: true,
              available: true,
            },
          ],
        },
        {
          name: 'uiAdditionalTypesCode',
          options: [
            {
              available: true,
              selected: true,
              value: 'UI-D-Cine',
              negate: true,
            },
          ],
        },
      ],
    },
    nearMe: {
      index: ['events_search'],
      modal: 'events_search',
      facets: [
        {
          name: 'uiAdditionalTypesCode',
          options: [
            {
              available: true,
              selected: true,
              value: 'UI-D-Cine',
              negate: true,
            },
          ],
        },
      ],
      options: {
        aroundRadius: {
          events_search: 50000,
        },
      },
    },
    familyFriendly: {
      index: ['events_search'],
      modal: 'events_search',
      facets: [
        {
          name: 'audience',
          options: [
            {
              available: true,
              selected: true,
              value: 'Family',
            },
            {
              available: true,
              selected: true,
              value: 'Toddler',
            },
            {
              available: true,
              selected: true,
              value: 'Childhood',
            },
            {
              available: true,
              selected: true,
              value: 'Children',
            },
          ],
        },
      ],
    },
    everyone: {
      index: ['events_search'],
      modal: 'events_search',
      facets: [
        {
          name: 'audience',
          options: [
            {
              available: true,
              selected: true,
              value: 'General',
            },
          ],
        },
      ],
    },
    thisWeek: {
      index: ['events_search'],
      modal: 'events_search',
      dateFilters: convertTimeRangeToFilterFacet(getTimeRangeFromTime(Time.THIS_WEEK)),
    },
    expositions: {
      index: ['exhibitions_search'],
      modal: 'exhibitions_search',
    },
  },
} as Configs
